import { EventEmitter } from '@angular/core';
import { LIMIT } from '@authority-labs/constants';
import { UploadEntity } from '@check-list/core/models/upload-entity.model';
import { UploadFile } from '@check-list/core/models/upload-file.model';
import { NzUploadFile } from 'ng-zorro-antd/upload';

export class UploadDirectoryDto {
  width?: string;
  namePath: string;
  id: string;
  filesListChanged?: EventEmitter<UploadFile>;
  uploadEntity: UploadEntity;
}

export class UploadDirectory {
  width?: string;
  namePath: string;
  id: string;
  filesListChanged?: EventEmitter<UploadFile>;
  uploadEntity: UploadEntity;

  constructor(uploadDirectoryDto: UploadDirectoryDto) {
    this.width = uploadDirectoryDto.width;
    this.namePath = uploadDirectoryDto.namePath;
    this.id = uploadDirectoryDto.id;
    this.filesListChanged = uploadDirectoryDto.filesListChanged;
    this.uploadEntity = uploadDirectoryDto.uploadEntity;
  }

  beforeUpload = (file?: NzUploadFile): boolean => {
    const uploadFile = new UploadFile(file, this);
    if (file.size > LIMIT.MAX_UPLOAD_SIZE) {
      uploadFile.filteredBy = 'tooBigFile';
    } else {
      uploadFile.isReady = true;
    }

    if (this.filesListChanged) {
      this.filesListChanged.emit(uploadFile);
    }
    return false;
  };
}
